import l from "./ghl-ui.es1183.js";
import s from "./ghl-ui.es1157.js";
import { changeColor as d } from "./ghl-ui.es904.js";
const n = (t) => {
  const {
    primaryColor: r,
    opacityDisabled: a,
    borderRadius: o,
    textColor3: i
  } = t, e = "rgba(0, 0, 0, .14)";
  return Object.assign(Object.assign({}, l), {
    iconColor: i,
    textColor: "white",
    loadingColor: r,
    opacityDisabled: a,
    railColor: e,
    railColorActive: r,
    buttonBoxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.3), inset 0 0 1px 0 rgba(0, 0, 0, 0.05)",
    buttonColor: "#FFF",
    railBorderRadiusSmall: o,
    railBorderRadiusMedium: o,
    railBorderRadiusLarge: o,
    buttonBorderRadiusSmall: o,
    buttonBorderRadiusMedium: o,
    buttonBorderRadiusLarge: o,
    boxShadowFocus: `0 0 0 2px ${d(r, {
      alpha: 0.2
    })}`
  });
}, c = {
  name: "Switch",
  common: s,
  self: n
}, g = c;
export {
  g as default
};
